import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AnimatedWrapper from '../components/AnimatedWrapper';
import ProgressBar from '../components/ProgressBar';
import { IoIosArrowBack } from 'react-icons/io';
import {marks} from "../config/data"
import { useUser } from '../context/useInfo';
import amplitude from '../utils/amplitude';


export default function Page33() {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
    const {updateUserData} = useUser()

    useEffect(() => {
          if(process.env.NODE_ENV === "production"){
                amplitude.track('Quiz Step Open', {
              step_number:33,
            });
              }
    }, [])


      const stepBack = () => {
        updateUserData({brandLoyal: ""})
    navigate('/quiz32')
  }
  const nextStep = (option) => {
    updateUserData({brandLoyal: option})
    if(process.env.NODE_ENV === "production") {
      amplitude.track('Quiz Step Complete', {
        step_number: 33, 
        answers:{brandLoyal: option}
      });
    }
    navigate('/quiz34')
  }

  return (
 <AnimatedWrapper>
    
      {/* Верхняя панель с кнопкой назад и прогрессом */}
      <div className="flex items-center space-x-2 pt-4 mb-3">
          <button className="text-gray-600" onClick={() => stepBack()}>
            <IoIosArrowBack size={24} />
          </button>
          <ProgressBar />
        </div>

      {/* Вопрос */}
      <h2 className="text-base text-gray-700 mb-3 mx-auto">Do you relate to this statement?</h2>

      {/* Основной текст */}
      <p className="text-lg font-semibold text-center mb-8 px-4">
        “Brand loyalty matters to me”
      </p>

      {/* Шкала оценок */}
<div className="flex gap-3 mx-auto max-w-md w-full">
  {marks.map((num) => (
    <button
      key={num}
      onClick={() => nextStep(num)}
      className="flex-1 py-4 text-center bg-white rounded-full shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 hover:border-gray-200"
    >
      {num}
    </button>
  ))}
</div>

      {/* Подписи под шкалой */}
      <div className="flex justify-between max-w-md w-full mx-auto mt-2 px-2 text-xs text-gray-600 select-none">
  <span>Strongly disagree</span>
  <span>Strongly agree</span>
</div>
   </AnimatedWrapper>
     
  );
}
